import { observable } from "mobx";
import StripeCard from "./StripeCard";

class StripeConnect {
  /**
   * @property {string}
   */
  @observable providerPublishableKey;

  /**
   * @property {object} defaultCreditCard stripe credit card object
   */
  @observable defaultCreditCard;

  /**
   * @property {array} creditCards instance of models/StripeCard
   */
  @observable creditCards = [];

  /**
   * @property {string}
   */
  @observable currency;

  constructor({ providerPublishableKey = "", defaultCreditCard = null, currency = "", creditCards = [] }) {
    this.providerPublishableKey = providerPublishableKey;
    this.currency = currency;
    this.defaultCreditCard = defaultCreditCard ? new StripeCard(defaultCreditCard) : null;

    creditCards.forEach(creditCard => {
      this.creditCards.push(new StripeCard(creditCard));
    });
  }
}

export default StripeConnect;
